import { render, staticRenderFns } from "./TeachRoomEbook.vue?vue&type=template&id=1f7f4b06&scoped=true&"
import script from "./TeachRoomEbook.vue?vue&type=script&lang=js&"
export * from "./TeachRoomEbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7f4b06",
  null
  
)

export default component.exports